<template>
<span>
    <v-layout mb-4>
        <v-flex xs10 ml-3>
            <h2 class="lime--text lighten-1 pt-3">Gerenciar Categorias - Inclusão</h2>
        </v-flex>
        <v-flex xs2 mr-3 text-right>
            <v-btn color="blue-grey" class="black--text" :to="{name: 'store-gift-list-categories'}">
                <v-icon dark>keyboard_arrow_left</v-icon>
                Voltar
            </v-btn>
        </v-flex>
    </v-layout>
    <form-store-gift-list-category :btnLabel="btnLabel"></form-store-gift-list-category>
</span>
</template>

<script>
import FormStoreGiftListCategoryComponent from "./partial/FormStoreGiftListCategoryComponent";

export default {
    name: "AddStoreGiftListCategoryComponent",
    data() {
        return {
            btnLabel: 'Incluir'
        }
    },
    methods: {

    },
    components: {
        formStoreGiftListCategory: FormStoreGiftListCategoryComponent,
    }
};
</script>

<style scoped>

</style>
